<script>
import { mapGetters } from 'vuex';

import ProductListLoader from './ProductListLoader.vue';
import ProductListHeader from './ProductListHeader.vue';
import ProductListPagination from './ProductListPagination.vue';
import ProductListTable from './ProductListTable.vue';
import ProductEmptyList from './ProductEmptyList.vue';

export default {
  name: 'ProductList',
  components: {
    ProductListLoader,
    ProductListHeader,
    ProductListPagination,
    ProductListTable,
    ProductEmptyList,
  },
  computed: {
    ...mapGetters({
      products: 'search/products',
    }),
    isLoading() {
      return !this.products;
    },
    isEmpty() {
      return this.products?.length === 0;
    },
  },
};
</script>

<template>
  <div>
    <ProductListLoader v-if="isLoading" />

    <ProductEmptyList class="my-24" v-else-if="isEmpty" />

    <div v-else>
      <div class="flex items-center justify-between">
        <ProductListHeader />
        <ProductListPagination class="ml-8" />
      </div>

      <ProductListTable class="mt-6" />

      <ProductListPagination class="mt-8 border-t border-gray-200 pt-8" />
    </div>
  </div>
</template>
